import TaskStatus from "./task-status"
import Collection from "../../data-structures/collection"

export default class TaskStatusesCollection extends Collection<TaskStatus> {

    static initFromJson(data:JSONArray):TaskStatusesCollection {
        const collection = new TaskStatusesCollection([])

        _.map(data, (record:JSONObject)=>{
            collection.add(new TaskStatus(record))
        })

        collection.sort()

        return collection
    }

    /*comparator(m) {
        if (m.status) {
            return m.systemStatus*100+m.sortPosition;
        } else {
            return m.sortPosition;
        }
    },*/

    sort() {
        this.models = _.orderBy(this.models, (model:TaskStatus) => {
            if (model.status) {
                return (model.systemStatus * 100) + model.sortPosition
            } else {
                return model.sortPosition
            }
        })
    }

    getByStatusId(statusId: ID) {
        return _.find(this.models, (model:TaskStatus)=>model.status.id == statusId)
    }

    findBySystemStatus(arrStatuses: ID[]) {
        return _.filter(this.models, (model:TaskStatus) => arrStatuses.includes(model.status.systemStatus))
    }

    filterOpenStatuses() {
        const filteredModels: TaskStatus[] = _.filter(this.models, (model:TaskStatus) => gd.const.systemStatus.isOpen(model.systemStatus)) as TaskStatus[]

        const collection = new TaskStatusesCollection()
        collection.reset(filteredModels)
        collection.sort()

        return collection
    }

    exportToOptions() {
        return _.map(this.models, (model:TaskStatus) => {
            return {
                value       : model.status.id,
                label       : model.status.name,
                // colorClass: 'status-color-'+model.status.color,
                color       : model.status.color,
                systemStatus: model.status.systemStatus
            }
        })
    }
}